// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photoItem {
  width: 90%;
  height: 90%;
  position: relative;
}
.photoItem .photoItemIcon {
  width: 100%;
  height: 100%;
}
.photoItem .photoItemIcon i {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.photoItem .photoItemIcon i svg {
  width: 90%;
  height: 90%;
}
.photoItemLoadingText {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sliderWrap {
  position: absolute;
  z-index: 20;
}
.sliderWrap .ant-slider {
  width: 120px;
  margin: 5px;
  margin-right: 20px;
  top: 120px;
  left: 16px;
}
.sliderWrap .ant-slider:hover .ant-slider-track {
  background-color: #757575 !important;
}
.sliderWrap .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #757575;
}
.sliderWrap .ant-slider-step {
  border: 1px solid #757575;
  border-radius: 4px;
  background: #F3F4F5;
}
.sliderWrap .ant-slider-handle {
  width: 12px;
  height: 12px;
  background-color: #757575;
  border: 1px solid #757575;
  transition: unset;
}
.sliderWrap .ant-slider-handle:focus {
  border-color: #757575;
}
.photoAndXRaysWrapper {
  width: 0;
  height: 0;
  overflow: unset !important;
  left: 148px !important;
  top: -40px !important;
}
.photoAndXRaysWrapper .photoBox {
  overflow: hidden;
}
.photoAndXRaysWrapper .dragAndResize {
  width: 100%;
}
.photoAndXRaysWrapper .photoContainer {
  position: relative;
  overflow: hidden;
}
.photoAndXRaysWrapper .photoContainer .photo {
  height: calc((100vw / 3 - 68px) / 1.1);
  background-color: white;
  border-radius: 8px;
}
.photoAndXRaysWrapper .photoContainer .photo.lastItem {
  margin-bottom: 0;
}
.photoAndXRaysWrapper .photoContainer .photo .picture {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.photoAndXRaysWrapper .photoContainer .photo .picture img {
  width: 90%;
  height: 90%;
  object-fit: cover;
}
.photoAndXRaysWrapper .photoContainer .photo p {
  margin-top: 20px;
  font-size: 14px;
}
.photoAndXRaysWrapper .ant-modal {
  pointer-events: unset !important;
  max-width: unset !important;
}
.photoAndXRaysWrapper .ant-modal-content {
  height: 100%;
  background-color: transparent;
}
.photoAndXRaysWrapper .ant-modal-close-x {
  width: 34px;
  height: 34px;
  line-height: 34px;
}
.photoAndXRaysWrapper .ant-modal-header {
  padding: 0px;
  cursor: move;
  background-color: #F7F7F7;
}
.photoAndXRaysWrapper .ant-modal-header .photoHeader {
  height: 70px;
}
.photoAndXRaysWrapper .ant-modal-header .photoHeader::after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.photoAndXRaysWrapper .ant-modal-body {
  padding: 0;
  background-color: #F7F7F7;
  height: calc(100% - 70px);
}
.photoAndXRaysWrapper .buttonStyle {
  position: relative;
  width: 115px;
  height: 30px;
  text-align: center;
  display: inline-block;
  border: 1px solid #DCDDE0;
  border-radius: 8px;
  cursor: pointer;
  color: #888888;
  transition: 0.3s;
  background-color: white;
}
.photoAndXRaysWrapper .buttonStyle div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.photoAndXRaysWrapper .ant-slider {
  width: 120px;
  margin: 5px;
  margin-right: 20px;
}
.photoAndXRaysWrapper .ant-slider:hover .ant-slider-track {
  background-color: #757575 !important;
}
.photoAndXRaysWrapper .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #757575;
}
.photoAndXRaysWrapper .ant-slider-step {
  border: 1px solid #757575;
  border-radius: 4px;
  background: #F3F4F5;
}
.photoAndXRaysWrapper .ant-slider-handle {
  width: 12px;
  height: 12px;
  background-color: #757575;
  border: 1px solid #757575;
  transition: unset;
}
.photoAndXRaysWrapper .ant-slider-handle:focus {
  border-color: #757575;
}
.photoAndXRaysWrapper .ant-carousel {
  height: 100%;
}
.photoAndXRaysWrapper .ant-carousel .slick-slider {
  height: 100%;
}
.photoAndXRaysWrapper .ant-carousel .slick-slider .slick-list {
  height: 100%;
  overflow: hidden;
}
.photoAndXRaysWrapper .ant-carousel .slick-slider .slick-list .bscroll-vertical-scrollbar {
  width: 9px !important;
  transition: 0.3s;
  opacity: 0;
}
.photoAndXRaysWrapper .ant-carousel .slick-slider .slick-list .bscroll-vertical-scrollbar .bscroll-indicator {
  border-radius: 9px !important;
  border: none !important;
  cursor: pointer;
}
.photoAndXRaysWrapper .ant-carousel .slick-slide {
  height: unset;
}
.photoAndXRaysWrapper .ant-carousel .slick-dots li.slick-active {
  width: unset;
}
.photoAndXRaysWrapper .slick-dots {
  top: -32px !important;
  left: calc((50% - 171px) / 2) !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  display: inline-block !important;
  width: fit-content;
}
.photoAndXRaysWrapper .slick-dots li {
  width: unset !important;
  display: inline-block !important;
  float: left;
  margin: 0 !important;
  text-indent: unset !important;
  height: unset !important;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper {
  width: 25px;
  height: 25px;
  background-color: white;
  position: relative;
  border: 1px solid lightgray;
  cursor: pointer;
  transition: 0.3s;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper.activePage {
  border-color: #0076FF;
  z-index: 20;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper .thumbText {
  width: 240px;
  display: none;
  transition: 0.3s;
  text-align: left;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper:hover {
  width: 35px;
  height: 35px;
  margin-top: -11px;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper:hover .thumbText {
  display: block;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper:hover svg {
  font-size: 35px;
}
.photoAndXRaysWrapper .slick-dots li .thumbWrapper:hover img {
  width: 33px;
  height: 33px;
  object-fit: cover;
}
.photoAndXRaysWrapper .slick-dots li svg {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 25px;
  transition: 0.3s;
}
.photoAndXRaysWrapper .slick-dots li img {
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.3s;
  width: 23px;
  height: 23px;
  object-fit: cover;
}
.photoAndXRaysWrapper .ant-carousel .slick-next {
  right: 10px;
}
.photoAndXRaysWrapper .ant-carousel .slick-prev {
  left: 10px;
  z-index: 30;
}
.photoAndXRaysWrapper .ant-carousel .slick-prev,
.photoAndXRaysWrapper .ant-carousel .slick-next,
.photoAndXRaysWrapper .ant-carousel .slick-prev:hover,
.photoAndXRaysWrapper .ant-carousel .slick-next:hover {
  font-size: 20px;
  color: currentColor;
  opacity: 0.15;
  transition: 0.3s;
  background-color: unset;
  color: unset;
}
.photoAndXRaysWrapper .ant-carousel .slick-prev:hover,
.photoAndXRaysWrapper .ant-carousel .slick-next:hover,
.photoAndXRaysWrapper .ant-carousel .slick-prev:hover:hover,
.photoAndXRaysWrapper .ant-carousel .slick-next:hover:hover {
  opacity: 1;
  background-color: unset;
  color: unset;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/Photo/index.less"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AADF;AAFA;EAMI,WAAA;EACA,YAAA;AADJ;AANA;EAUM,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAbA;EAiBQ,UAAA;EACA,WAAA;AADR;AAOA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALF;AAQA;EACE,kBAAA;EACA,WAAA;AANF;AAIA;EAKI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AANJ;AAQI;EAEI,oCAAA;AAPR;AANA;EAmBI,qBAAA;AAVJ;AATA;EA2BI,yBAAA;EACA,kBAAA;EACA,mBAAA;AAfJ;AAdA;EAiCI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AAhBJ;AAkBI;EACE,qBAAA;AAhBN;AAqBA;EACE,QAAA;EACA,SAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;AAnBF;AAcA;EAQI,gBAAA;AAnBJ;AAWA;EAaI,WAAA;AArBJ;AAQA;EAkBI,kBAAA;EAGA,gBAAA;AAzBJ;AAIA;EA0BM,sCAAA;EACA,uBAAA;EACA,kBAAA;AA3BN;AA6BM;EACE,gBAAA;AA3BR;AAJA;EAmCQ,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BR;AAZA;EA0DU,UAAA;EACA,WAAA;EACA,iBAAA;AA3CV;AAjBA;EAiEQ,gBAAA;EACA,eAAA;AA7CR;AArBA;EAwEI,gCAAA;EACA,2BAAA;AAhDJ;AAzBA;EA6EI,YAAA;EAEA,6BAAA;AAlDJ;AA7BA;EAsFI,WAAA;EACA,YAAA;EACA,iBAAA;AAtDJ;AAlCA;EA6FI,YAAA;EACA,YAAA;EACA,yBAAA;AAxDJ;AAvCA;EAkGM,YAAA;AAxDN;AA0DM;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AAxDR;AAjDA;EA+GI,UAAA;EACA,yBAAA;EACA,yBAAA;AA3DJ;AAtDA;EAqHI,kBAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AA7DJ;AAnEA;EAmIM,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7DN;AA1EA;EA4II,YAAA;EACA,WAAA;EACA,kBAAA;AA/DJ;AAiEI;EAEI,oCAAA;AAhER;AAlFA;EAwJI,qBAAA;AAnEJ;AArFA;EAgKI,yBAAA;EACA,kBAAA;EACA,mBAAA;AAxEJ;AA1FA;EAsKI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AAzEJ;AA2EI;EACE,qBAAA;AAzEN;AApGA;EAkLI,YAAA;AA3EJ;AAvGA;EAqLM,YAAA;AA3EN;AA1GA;EAwLQ,YAAA;EACA,gBAAA;AA3ER;AA9GA;EA4LU,qBAAA;EACA,gBAAA;EACA,UAAA;AA3EV;AAnHA;EAiMY,6BAAA;EACA,uBAAA;EACA,eAAA;AA3EZ;AAxHA;EA2MI,aAAA;AAhFJ;AA3HA;EA+MI,YAAA;AAjFJ;AA9HA;EAoNI,qBAAA;EACA,wCAAA;EAEA,0BAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;AApFJ;AAtIA;EA6NM,uBAAA;EACA,gCAAA;EACA,WAAA;EAEA,oBAAA;EACA,6BAAA;EACA,wBAAA;AArFN;AA9IA;EAsOQ,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AArFR;AAuFQ;EACE,qBAAA;EACA,WAAA;AArFV;AA3JA;EAoPU,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAtFV;AAyFQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAvFV;AAoFQ;EAMI,cAAA;AAvFZ;AAiFQ;EAUI,eAAA;AAxFZ;AA8EQ;EAcI,WAAA;EACA,YAAA;EACA,iBAAA;AAzFZ;AAjLA;EAgRQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,gBAAA;AA5FR;AAxLA;EAwRQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA7FR;AAjMA;EAoSI,WAAA;AAhGJ;AApMA;EAwSI,UAAA;EACA,WAAA;AAjGJ;AAxMA;;;;EAgTI,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAlGJ;AAqGI;;;;EACE,UAAA;EAEA,uBAAA;EACA,YAAA;AAjGN","sourcesContent":["@import \"src/style/common.less\";\n\n.photoItem {\n  width: 90%;\n  height: 90%;\n  position: relative;\n\n  .photoItemIcon {\n    width: 100%;\n    height: 100%;\n\n    i {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      svg {\n        width: 90%;\n        height: 90%;\n      }\n    }\n  }\n}\n\n.photoItemLoadingText {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sliderWrap {\n  position: absolute;\n  z-index: 20;\n\n  .ant-slider {\n    width: 120px;\n    margin: 5px;\n    margin-right: 20px;\n    top: 120px;\n    left: 16px;\n\n    &:hover {\n      .ant-slider-track {\n        background-color: #757575 !important;\n      }\n    }\n  }\n\n  .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n    border-color: #757575;\n  }\n\n  .ant-slider-rail {\n    //display: none;\n  }\n\n  .ant-slider-step {\n    border: 1px solid #757575;\n    border-radius: 4px;\n    background: #F3F4F5;\n  }\n\n  .ant-slider-handle {\n    width: 12px;\n    height: 12px;\n    background-color: #757575;\n    border: 1px solid #757575;\n    transition: unset;\n\n    &:focus {\n      border-color: #757575;\n    }\n  }\n}\n\n.photoAndXRaysWrapper {\n  width: 0;\n  height: 0;\n  overflow: unset !important;\n  left: 148px !important;\n  top: -40px !important;\n\n  .photoBox {\n    overflow: hidden;\n  }\n\n\n  .dragAndResize {\n    width: 100%;\n  }\n\n  .photoContainer {\n    //padding: 0 4px 4px 4px;\n    position: relative;\n    //background-color: #F7F7F7;\n    //height: 100%;\n    overflow: hidden;\n\n\n    .photo {\n      //width: calc(100% - 8px);\n      height: calc((100vw / 3 - 68px) / 1.1);\n      background-color: white;\n      border-radius: 8px;\n\n      &.lastItem {\n        margin-bottom: 0;\n      }\n\n      .picture {\n        width: 100%;\n        height: 100%;\n        //border: 1px dashed lightgray;\n        border-radius: 8px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n\n        // i {\n        //   width: 100%;\n        //   height: 100%;\n        //   display: flex;\n        //   justify-content: center;\n        //   align-items: center;\n\n        //   svg {\n        //     width: 90%;\n        //     height: 90%;\n        //   }\n        // }\n\n        img {\n          width: 90%;\n          height: 90%;\n          object-fit: cover;\n        }\n      }\n\n      p {\n        margin-top: 20px;\n        font-size: 14px;\n      }\n    }\n  }\n\n  .ant-modal {\n    pointer-events: unset !important;\n    max-width: unset !important;\n  }\n\n  .ant-modal-content {\n    height: 100%;\n    //width: 100vw / 3;\n    background-color: transparent;\n  }\n\n  .opacity {}\n\n  .ant-modal-close-x {\n    //display: none;\n    width: 34px;\n    height: 34px;\n    line-height: 34px;\n  }\n\n  .ant-modal-header {\n    //border-bottom: none;\n    padding: 0px;\n    cursor: move;\n    background-color: #F7F7F7;\n\n    .photoHeader {\n      height: 70px;\n\n      &::after {\n        content: \"\";\n        display: block;\n        height: 0;\n        clear: both;\n        visibility: hidden;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    background-color: #F7F7F7;\n    height: calc(100% - 70px);\n  }\n\n  .buttonStyle {\n    position: relative;\n    width: 115px;\n    height: 30px;\n    //line-height: 30px;\n    text-align: center;\n    display: inline-block;\n    border: 1px solid #DCDDE0;\n    border-radius: 8px;\n    cursor: pointer;\n    color: #888888;\n    transition: .3s;\n    background-color: white;\n\n    div {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .ant-slider {\n    width: 120px;\n    margin: 5px;\n    margin-right: 20px;\n\n    &:hover {\n      .ant-slider-track {\n        background-color: #757575 !important;\n      }\n    }\n  }\n\n  .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n    border-color: #757575;\n  }\n\n  .ant-slider-rail {\n    //display: none;\n  }\n\n  .ant-slider-step {\n    border: 1px solid #757575;\n    border-radius: 4px;\n    background: #F3F4F5;\n  }\n\n  .ant-slider-handle {\n    width: 12px;\n    height: 12px;\n    background-color: #757575;\n    border: 1px solid #757575;\n    transition: unset;\n\n    &:focus {\n      border-color: #757575;\n    }\n  }\n\n  .ant-carousel {\n    height: 100%;\n\n    .slick-slider {\n      height: 100%;\n\n      .slick-list {\n        height: 100%;\n        overflow: hidden;\n\n        .bscroll-vertical-scrollbar {\n          width: 9px !important;\n          transition: .3s;\n          opacity: 0;\n\n          .bscroll-indicator {\n            border-radius: 9px !important;\n            border: none !important;\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n\n  .ant-carousel .slick-slide {\n    height: unset;\n  }\n\n  .ant-carousel .slick-dots li.slick-active {\n    width: unset;\n  }\n\n\n  .slick-dots {\n    top: -32px !important;\n    left: calc((50% - 171px) / 2) !important;\n    //justify-content: center !important;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    display: inline-block !important;\n    width: fit-content;\n\n    li {\n      width: unset !important;\n      display: inline-block !important;\n      float: left;\n      //background-color: #0076FF;\n      margin: 0 !important;\n      text-indent: unset !important;\n      height: unset !important;\n\n      .thumbWrapper {\n        width: 25px;\n        height: 25px;\n        background-color: white;\n        position: relative;\n        border: 1px solid lightgray;\n        cursor: pointer;\n        transition: .3s;\n\n        &.activePage {\n          border-color: #0076FF;\n          z-index: 20;\n        }\n\n        .thumbText {\n          width: 240px;\n          display: none;\n          transition: .3s;\n          text-align: left;\n        }\n\n        &:hover {\n          width: 35px;\n          height: 35px;\n          margin-top: -11px;\n\n          .thumbText {\n            display: block;\n          }\n\n          svg {\n            font-size: 35px;\n          }\n\n          img {\n            width: 33px;\n            height: 33px;\n            object-fit: cover;\n          }\n        }\n      }\n\n      svg {\n        position: absolute;\n        top: 0;\n        left: 0;\n        font-size: 25px;\n        transition: .3s;\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        transition: .3s;\n        width: 23px;\n        height: 23px;\n        object-fit: cover;\n      }\n    }\n  }\n\n  .ant-carousel .slick-next {\n    right: 10px;\n  }\n\n  .ant-carousel .slick-prev {\n    left: 10px;\n    z-index: 30;\n  }\n\n  .ant-carousel .slick-prev,\n  .ant-carousel .slick-next,\n  .ant-carousel .slick-prev:hover,\n  .ant-carousel .slick-next:hover {\n    font-size: 20px;\n    color: currentColor;\n    opacity: 0.15;\n    transition: .3s;\n    background-color: unset;\n    color: unset;\n    //top: -20px;\n\n    &:hover {\n      opacity: 1;\n\n      background-color: unset;\n      color: unset;\n    }\n  }\n}\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
